import styled from 'styled-components';
import { palette } from 'styled-theme';

import { media } from '../../../helper/styleHelper';

export const StyledSwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;
export const StyledSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 30px;
  height: 19px;
  ${media.md`
  width: 40px;
  height: 26px;
  `}
  ${media.xxl`
  width: 50px;
  height: 35px;
  `}
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 8px;
    width: 8px;
    left: 4px;
    bottom: 5.7px;
    ${media.md`
    height: 14px;
    width: 14px;
    bottom: 6.7px;
  `}
    ${media.xxl`
    height: 16px;
    width: 16px;
    bottom: 10.7px;
    `}
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked:disabled + .slider {
    background-color: ${palette('gray', 0)};
  }

  input:disabled + .slider {
    background-color: ${palette('gray', 0)};
  }

  input:checked + .slider {
    background-color: ${palette('background', 2)};
  }

  input:focus + .slider {
    box-shadow: 0 0 1px ${palette('background', 2)};
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(20px);
    -ms-transform: translateX(20px);
    transform: translateX(20px);
    ${media.xxl`
    -webkit-transform: translateX(25px);
    -ms-transform: translateX(25px);
    transform: translateX(25px);
    `}
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
`;
